import React from "react";
import NewsCard from "../News/NewsCard";
import NewsCategoryTitle from "../NewsCategory/NewsCategoryTitle";
import { useSelector } from "react-redux";
import { withTranslation } from 'react-i18next';

const Layout4 = ({ titleColor, data, name, logo, props, analyticsInfo }) => {

  const isPreview = useSelector(state => state.info.isPreview);
  const warningOn = data.length < 3 ? true : false;
  const { t } = props;

  return data ? (
    <div>
      <NewsCategoryTitle
        props={props}
        isFixedLayout={false}
        titleColor={titleColor}
        name={name}
        analyticsInfo={analyticsInfo}
        logo={logo}
      />
      {isPreview && warningOn &&
        <div class="alert alert-warning pl-3">
          <strong>{t("errors.warning")}</strong> {t("errors.insuficientContent")}
        </div>
      }
      {data.length > 0 ?
        <div className="row pl-3">
          <div className="col-12 col-md-9 pl-0">
            <NewsCard
              id={data[0]?.id}
              type="card"
              icon={data[0]?.fields?.has_video ? "video_icon" : "link_icon"}
              cardSize="card_news three_col_news"
              cardinfo={data[0]}
              image={data[0]?.fields?.cover_image?.directURLArray.large}
              imageClass={data[0]?.fields?.image_alignment}
              createdDate={
                data[0]?.fields?.authoring_date?.value
              }
              summary={data[0]?.fields?.title}
              tagList={data[0]?.fields?.tags_list}
              analyticsInfo={analyticsInfo}
            />
          </div>

          <div className="col-12 col-md-3 pl-0">
            {data.slice(1, 3).map((card, index) => (
              <NewsCard
                id={card?.id}
                key={index}
                type="card"
                icon={card?.fields?.has_video ? "video_icon" : "link_icon"}
                key={index}
                cardSize="card_news square"
                cardinfo={card}
                image={card?.fields?.cover_image?.directURLArray.medium}
                imageClass={card?.fields?.image_alignment}
                createdDate={
                  card?.fields?.authoring_date?.value
                }
                summary={card?.fields?.title}
                tagList={card?.fields?.tags_list}
                analyticsInfo={analyticsInfo}
              />
            ))}
          </div>
        </div>
        : null}
    </div>
  ) : null;
};

export default withTranslation()(Layout4);
